import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import UnsubscribeButton from 'components/Payments/UnsubscribeButton';
import DefaultButton from 'components/Utils/NewDefaultButton';
import RouteUtils from 'services/RouteUtils';
import SubscriptionUtils from 'services/SubscriptionUtils';
import CalendarUtils from 'services/CalendarUtils';
import { PlanDetails } from 'components/Payments/SubscribeScreen/view';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import './style.scss';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';

const STYLE = { width: '80%', margin: '2px auto' };

const SubscriptionList = ({ patient }) => {
  const dispatch = useAppDispatch();
  const nav = useNavStack(Stacks.Master);

  const allSubscriptions = useAppSelector((state) => state.payments.subscriptions);
  const authentication = useAppSelector((state) => state.authentication);

  const patientId = patient.id;
  const subscription = allSubscriptions[patientId];
  const isPatient = authentication.role === 'patient';

  const isActiveSubscription = SubscriptionUtils.isActiveSubscription(subscription);

  useEffect(() => {
    dispatch(api.Payments.getUserSubscription({ userId: patientId }));
  }, [dispatch, patientId, isActiveSubscription]);

  function subscribe() {
    let route = RouteUtils.getRoute(RouteUtils.routes().subscribe, {
      ':step?': undefined,
    });
    nav.push(route);
  }

  let disabled = subscription?.cancel_at_period_end === true;

  let showUnsubscribeButton =
    isActiveSubscription && !SubscriptionUtils.isUnsubscribed(subscription);

  const isInMinimumMonths = SubscriptionUtils.stillInMinimumMonths(subscription);

  const billingPeriodText = isInMinimumMonths
    ? 'minimum commitment period'
    : 'current billing cycle';

  return (
    <div className="subscription-list row">
      <span className="small-title">Current Subscription</span>
      <div className="row full-width">
        {!!subscription && (
          <>
            {isPatient && (
              <PlanDetails
                plan={(subscription || {}).plan}
                subscription={subscription}
                button={
                  <>
                    <DefaultButton
                      style={STYLE}
                      className="blue"
                      name="Change Plan"
                      onClick={subscribe}
                    />
                    {showUnsubscribeButton && (
                      <UnsubscribeButton
                        patient={patient}
                        disabled={disabled}
                        style={STYLE}
                        subscription={subscription}
                      />
                    )}
                  </>
                }
              />
            )}
            {!isPatient && (
              <>
                <div className="row full-width">
                  <DefaultTextField
                    className="subscription"
                    name="subscription"
                    label="Subscription name"
                    value={SubscriptionUtils.getSubscriptionName(subscription)}
                    disabled={true}
                    style={{ width: '200px', display: 'inline-block' }}
                  />
                </div>
                <div className="row full-width">
                  <DefaultTextField
                    className="subscription"
                    name="referral_code"
                    label="Own Referral Code"
                    value={patient.referrer_code || ''}
                    disabled={true}
                    style={{ width: '200px', display: 'inline-block' }}
                  />
                </div>
                <div className="row full-width">
                  <DefaultTextField
                    className="subscription"
                    name="referral_code_applied"
                    label="Applied Referral Code"
                    value={patient.referral_code_applied || ''}
                    disabled={true}
                    style={{ width: '200px', display: 'inline-block' }}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
      {disabled && (
        <div className="row cancelled-text">
          This subscription has been cancelled and will terminate at the end of the{' '}
          {billingPeriodText} (
          {CalendarUtils.format(subscription?.cancel_at || subscription?.current_period_end)}
          ).
        </div>
      )}
    </div>
  );
};

SubscriptionList.propTypes = {
  patient: PropTypes.object.isRequired,
};

export default SubscriptionList;
